import { render, staticRenderFns } from "./TaggerModal.vue?vue&type=template&id=a459ff52"
import script from "./TaggerModal.vue?vue&type=script&lang=js"
export * from "./TaggerModal.vue?vue&type=script&lang=js"
import style0 from "./TaggerModal.vue?vue&type=style&index=0&id=a459ff52&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports